"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _sitecoreJssReact = require("@sitecore-jss/sitecore-jss-react");
var _headTags = _interopRequireDefault(require("../../components/headTags"));
var _Footer = _interopRequireDefault(require("../../components/Nav/Footer"));
var _Header = _interopRequireDefault(require("../../components/Nav/Header"));
var _AuthorInfo = _interopRequireDefault(require("../../components/Blog/AuthorInfo"));
var _BlogTags = _interopRequireDefault(require("../../components/Blog/BlogTags"));
var _LoadableComponent = _interopRequireDefault(require("../../components/LoadableComponent"));
var _lodash = require("lodash");
var _richTextField = require("../../lib/richTextField");
var _reactBootstrap = require("react-bootstrap");
var _imageSrc = require("../../lib/imageSrc");
var _globalDataContext = require("../../lib/globalDataContext");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _OnDemandScripts = _interopRequireDefault(require("../../components/OnDemandScripts"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
  APP LAYOUT
  This is where the app's HTML structure and root placeholders should be defined.

  All routes share this root layout by default (this could be customized in RouteHandler),
  but components added to inner placeholders are route-specific.
*/

var BlogFilterLayout = props => {
  var [currentSelection, setCurrentSelection] = (0, _react.useState)(null);
  var clickHandler = e => {
    setCurrentSelection(e);
  };
  var route = props.route;
  var fields = route.fields;
  var tags = (0, _lodash.map)(route.fields.Topic, (tag, key) => {
    return tag.name;
  });
  var data = fields.StateList.map((sList, sListKey) => {
    return {
      key: sListKey,
      label: sList.fields.Key.value,
      value: sList.fields.Value.value
    };
  });
  var GetContent = props => {
    var codeFound;
    var codeList = props.BlockedStateList.map((codes, codeKey) => {
      return {
        key: codeKey,
        value: codes.fields.Value.value
      };
    });
    codeFound = codeList.find(x => x.value === currentSelection);
    if (codeFound === undefined) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _richTextField.parseHTML)(fields.BodyCopy), /*#__PURE__*/_react.default.createElement("div", {
      className: "container mm-spacing caption"
    }, (0, _richTextField.parseHTML)(fields.ContentDisclosure)));else return (0, _richTextField.parseHTML)(fields.BlockedMessage);
  };
  var GetSideBar = props => {
    if (props.SideBar !== null) return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      md: 4,
      className: "offset-md-1"
    }, props.SideBar.fields.ShowForms.value === true && /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
      name: "right-rail",
      rendering: route,
      params: props.componentProps
    }), /*#__PURE__*/_react.default.createElement(_LoadableComponent.default, {
      name: 'BlogSideBar',
      rendering: props.SideBar,
      params: props.componentProps,
      parentComponent: "blog"
    }));else return null;
  };
  (0, _globalDataContext.setGlobalData)(props);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_headTags.default, props.headTagsProps), /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.VisitorIdentification, null), /*#__PURE__*/_react.default.createElement(_Header.default, {
    route: route,
    params: props.componentProps,
    headTagsProps: props.headTagsProps
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "container mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 1
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 8
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing"
  }), !(0, _lodash.isEmpty)(fields.Headline.value) && /*#__PURE__*/_react.default.createElement("h1", {
    className: "mm-spacing"
  }, fields.Headline.value), /*#__PURE__*/_react.default.createElement(_AuthorInfo.default, props.headTagsProps)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 3
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "img-fluid mm-spacing",
    src: (0, _imageSrc.imageHref)(fields.MainImage.value, props.appEnv),
    alt: fields.MainImage.value.alt
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 6,
    className: "article offset-md-1"
  }, /*#__PURE__*/_react.default.createElement("p", null, fields.ListHeading.value), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.DropdownSelect, {
    data: data,
    defaultLabel: fields.DefaultLabel.value,
    onSelect: clickHandler,
    toggleId: "StateList"
  }), /*#__PURE__*/_react.default.createElement("p", null, "\xA0"), currentSelection !== null ? /*#__PURE__*/_react.default.createElement(GetContent, fields) : ''), /*#__PURE__*/_react.default.createElement(GetSideBar, fields))), /*#__PURE__*/_react.default.createElement(_BlogTags.default, {
    tags: tags
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "container mm-spacing caption"
  }, (0, _richTextField.parseHTML)(fields.Disclosure)), /*#__PURE__*/_react.default.createElement(_Footer.default, {
    fields: route.fields,
    componentParams: props.componentProps,
    params: props.headTagsProps
  }), /*#__PURE__*/_react.default.createElement(_OnDemandScripts.default, {
    scriptList: route.fields.ScriptOnDemand
  }));
};
var _default = exports.default = BlogFilterLayout;